import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const MENU = [
  { label: "Account Settings", path: "/account/settings", icon: "⚙" },
  { label: "My Reports", path: "/account/reports", icon: "📄" },
  { label: "Accessibility", path: "/account/accessibility", icon: "♿" },
  { label: "Plans & Subscriptions", path: "/account/plans", icon: "💳" },
];

function Sidebar({ active }: { active: any }) {
  return (
    <div style={{ width: "220px", flexShrink: 0, background: "white", borderRadius: "14px", border: "1.5px solid #EAE6E0", padding: "16px 0", height: "fit-content" }}>
      {MENU.map(item => (
        <Link key={item.path} to={item.path}
          style={{ display: "flex", alignItems: "center", gap: "10px", padding: "11px 20px", fontSize: "14px", color: active === item.path ? "#C9A84C" : "var(--text-primary)", fontWeight: active === item.path ? 700 : 400, background: active === item.path ? "rgba(201,168,76,0.08)" : "transparent", borderLeft: active === item.path ? "3px solid #C9A84C" : "3px solid transparent", textDecoration: "none", transition: "all 0.15s" }}>
          <span>{item.icon}</span> {item.label}
        </Link>
      ))}
      <div style={{ borderTop: "1px solid #EAE6E0", margin: "8px 0" }}></div>
      <button onClick={() => { localStorage.removeItem("token"); window.location.href = "/"; }}
        style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%", padding: "11px 20px", fontSize: "14px", color: "#C0392B", background: "transparent", border: "none", cursor: "pointer", fontWeight: 500, borderLeft: "3px solid transparent" }}>
        <span>🚪</span> Logout
      </button>
    </div>
  );
}

export default function AccountSettings() {
  const [user, setUser] = useState<{[key: string]: string}>({ first_name: "", last_name: "", email: "", country: "" });
  const [saved, setSaved] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch("/api/auth/me", { headers: { Authorization: "Bearer " + token } })
        .then(r => r.json())
        .then(data => {
          if (data.email) {
            const parts = (data.name || "").split(" ");
            setUser({ first_name: parts[0] || "", last_name: parts.slice(1).join(" ") || "", email: data.email || "", country: "India" });
          }
        });
    }
  }, []);

  const handleSave = () => { setSaved(true); setTimeout(() => setSaved(false), 2500); };

  const inputStyle = { width: "100%", padding: "10px 14px", border: "1.5px solid #D8D4CE", borderRadius: "8px", fontSize: "14px", color: "var(--text-primary)", background: "var(--white)", outline: "none" };

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "32px 24px" }}>
      <h1 style={{ fontSize: "22px", fontWeight: 700, marginBottom: "24px", color: "var(--text-primary)" }}>Account</h1>
      <div style={{ display: "flex", gap: "24px", alignItems: "flex-start" }}>
        <Sidebar active={location.pathname} />
        <div style={{ flex: 1, background: "white", borderRadius: "14px", border: "1.5px solid #EAE6E0", padding: "28px 32px" }}>
          <h2 style={{ fontSize: "18px", fontWeight: 700, marginBottom: "24px", color: "var(--text-primary)", paddingBottom: "16px", borderBottom: "1px solid #EAE6E0" }}>Profile</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px" }}>
            {[
              { label: "First Name", key: "first_name" },
              { label: "Last Name", key: "last_name" },
              { label: "Email Address", key: "email" },
              { label: "Country", key: "country" },
            ].map(field => (
              <div key={field.key}>
                <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#5C5C5C", marginBottom: "6px" }}>{field.label}</label>
                <input value={user[field.key]} onChange={e => setUser({ ...user, [field.key]: e.target.value })}
                  style={inputStyle}
                  onFocus={e => { e.target.style.borderColor = "#C9A84C"; }}
                  onBlur={e => { e.target.style.borderColor = "#D8D4CE"; }} />
              </div>
            ))}
          </div>
          <div style={{ marginTop: "24px", display: "flex", alignItems: "center", gap: "12px" }}>
            <button onClick={handleSave} style={{ background: "#C9A84C", color: "#2C2C2C", border: "none", padding: "10px 24px", borderRadius: "8px", fontWeight: 700, fontSize: "14px", cursor: "pointer" }}>
              Save Changes
            </button>
            {saved && <span style={{ color: "#375623", fontSize: "13px", fontWeight: 600 }}>Changes saved!</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
